import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';
import { arrayToZodEnum } from '../../../util';
import { ParameterLevel, Parameters } from '../../../enums';

export const userGoalDto = z.object({
  name: z.string(),
  parameter: z.enum(arrayToZodEnum(Object.values(Parameters))),
  targetValue: z.union([
    z.string(),
    z.number(),
    z.enum(arrayToZodEnum(Object.values(ParameterLevel))),
  ]),
});

export class UserGoalDto extends createZodDto(userGoalDto) {}
